import { createContext } from 'react';
import { AddressFieldContextType } from './address-field-types';

export const AddressFieldContext = createContext<AddressFieldContextType>(
  undefined as any
);
